import { Component, OnInit } from '@angular/core';
import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';

@Component({
    selector: 'app-guest-login-popup',
    templateUrl: './guest-login-popup.component.html',
    styleUrls: ['./guest-login-popup.component.scss'],
    standalone: false
})
export class GuestLoginPopupComponent implements OnInit {

    
    constructor(
        public sopoDialogRef: SopoDialogRef,
    ) {}

    ngOnInit() {

    }

    close(accept: boolean): void {
        this.sopoDialogRef.close(accept);
    }
}
